@if (form) {
  <fieldset class="task-detail govuk-fieldset">
    <app-form [formElId]="form.id" [form]="form"></app-form>
    <button class="govuk-button" data-module="govuk-button"
      (click)="onStart(form)">
      Start
    </button>
  </fieldset>
}
